interface CountryData {
  name: {
    zh: string;
    en: string;
  };
  code: string;
  flag: string;
}

export const countries: CountryData[] = [
  // East Asia
  { name: { zh: '中国', en: 'China' }, code: 'CHINA', flag: '🇨🇳' },
  { name: { zh: '日本', en: 'Japan' }, code: 'JAPAN', flag: '🇯🇵' },
  { name: { zh: '韩国', en: 'South Korea' }, code: 'KOREA, REPUBLIC OF', flag: '🇰🇷' },
  { name: { zh: '朝鲜', en: 'North Korea' }, code: 'KOREA, DEMOCRATIC PEOPLE\'S REPUBLIC OF', flag: '🇰🇵' },
  { name: { zh: '蒙古', en: 'Mongolia' }, code: 'MONGOLIA', flag: '🇲🇳' },
  { name: { zh: '台湾', en: 'Taiwan' }, code: 'TAIWAN', flag: '🇹🇼' },
  { name: { zh: '香港', en: 'Hong Kong' }, code: 'HONG KONG', flag: '🇭🇰' },
  { name: { zh: '澳门', en: 'Macao' }, code: 'MACAO', flag: '🇲🇴' },

  // Southeast Asia
  { name: { zh: '新加坡', en: 'Singapore' }, code: 'SINGAPORE', flag: '🇸🇬' },
  { name: { zh: '马来西亚', en: 'Malaysia' }, code: 'MALAYSIA', flag: '🇲🇾' },
  { name: { zh: '泰国', en: 'Thailand' }, code: 'THAILAND', flag: '🇹🇭' },
  { name: { zh: '越南', en: 'Vietnam' }, code: 'VIET NAM', flag: '🇻🇳' },
  { name: { zh: '印度尼西亚', en: 'Indonesia' }, code: 'INDONESIA', flag: '🇮🇩' },
  { name: { zh: '菲律宾', en: 'Philippines' }, code: 'PHILIPPINES', flag: '🇵🇭' },
  { name: { zh: '缅甸', en: 'Myanmar' }, code: 'MYANMAR', flag: '🇲🇲' },
  { name: { zh: '柬埔寨', en: 'Cambodia' }, code: 'CAMBODIA', flag: '🇰🇭' },
  { name: { zh: '老挝', en: 'Laos' }, code: 'LAO PEOPLE\'S DEMOCRATIC REPUBLIC', flag: '🇱🇦' },
  { name: { zh: '文莱', en: 'Brunei' }, code: 'BRUNEI DARUSSALAM', flag: '🇧🇳' },
  { name: { zh: '东帝汶', en: 'Timor-Leste' }, code: 'TIMOR-LESTE', flag: '🇹🇱' },

  // South Asia
  { name: { zh: '印度', en: 'India' }, code: 'INDIA', flag: '🇮🇳' },
  { name: { zh: '巴基斯坦', en: 'Pakistan' }, code: 'PAKISTAN', flag: '🇵🇰' },
  { name: { zh: '孟加拉国', en: 'Bangladesh' }, code: 'BANGLADESH', flag: '🇧🇩' },
  { name: { zh: '斯里兰卡', en: 'Sri Lanka' }, code: 'SRI LANKA', flag: '🇱🇰' },
  { name: { zh: '尼泊尔', en: 'Nepal' }, code: 'NEPAL', flag: '🇳🇵' },
  { name: { zh: '不丹', en: 'Bhutan' }, code: 'BHUTAN', flag: '🇧🇹' },
  { name: { zh: '马尔代夫', en: 'Maldives' }, code: 'MALDIVES', flag: '🇲🇻' },
  { name: { zh: '阿富汗', en: 'Afghanistan' }, code: 'AFGHANISTAN', flag: '🇦🇫' },

  // Central Asia
  { name: { zh: '哈萨克斯坦', en: 'Kazakhstan' }, code: 'KAZAKHSTAN', flag: '🇰🇿' },
  { name: { zh: '乌兹别克斯坦', en: 'Uzbekistan' }, code: 'UZBEKISTAN', flag: '🇺🇿' },
  { name: { zh: '吉尔吉斯斯坦', en: 'Kyrgyzstan' }, code: 'KYRGYZSTAN', flag: '🇰🇬' },
  { name: { zh: '塔吉克斯坦', en: 'Tajikistan' }, code: 'TAJIKISTAN', flag: '🇹🇯' },
  { name: { zh: '土库曼斯坦', en: 'Turkmenistan' }, code: 'TURKMENISTAN', flag: '🇹🇲' },

  // Middle East
  { name: { zh: '伊朗', en: 'Iran' }, code: 'IRAN, ISLAMIC REPUBLIC OF', flag: '🇮🇷' },
  { name: { zh: '沙特阿拉伯', en: 'Saudi Arabia' }, code: 'SAUDI ARABIA', flag: '🇸🇦' },
  { name: { zh: '阿联酋', en: 'United Arab Emirates' }, code: 'UNITED ARAB EMIRATES', flag: '🇦🇪' },
  { name: { zh: '以色列', en: 'Israel' }, code: 'ISRAEL', flag: '🇮🇱' },
  { name: { zh: '土耳其', en: 'Turkey' }, code: 'TURKEY', flag: '🇹🇷' },
  { name: { zh: '伊拉克', en: 'Iraq' }, code: 'IRAQ', flag: '🇮🇶' },
  { name: { zh: '卡塔尔', en: 'Qatar' }, code: 'QATAR', flag: '🇶🇦' },
  { name: { zh: '科威特', en: 'Kuwait' }, code: 'KUWAIT', flag: '🇰🇼' },
  { name: { zh: '约旦', en: 'Jordan' }, code: 'JORDAN', flag: '🇯🇴' },
  { name: { zh: '黎巴嫩', en: 'Lebanon' }, code: 'LEBANON', flag: '🇱🇧' },
  { name: { zh: '阿曼', en: 'Oman' }, code: 'OMAN', flag: '🇴🇲' },
  { name: { zh: '巴林', en: 'Bahrain' }, code: 'BAHRAIN', flag: '🇧🇭' },
  { name: { zh: '叙利亚', en: 'Syria' }, code: 'SYRIAN ARAB REPUBLIC', flag: '🇸🇾' },
  { name: { zh: '也门', en: 'Yemen' }, code: 'YEMEN', flag: '🇾🇪' },
  { name: { zh: '巴勒斯坦', en: 'Palestine' }, code: 'PALESTINE, STATE OF', flag: '🇵🇸' },

  // Europe
  { name: { zh: '英国', en: 'United Kingdom' }, code: 'UNITED KINGDOM OF GREAT BRITAIN AND NORTHERN IRELAND', flag: '🇬🇧' },
  { name: { zh: '法国', en: 'France' }, code: 'FRANCE', flag: '🇫🇷' },
  { name: { zh: '德国', en: 'Germany' }, code: 'GERMANY', flag: '🇩🇪' },
  { name: { zh: '意大利', en: 'Italy' }, code: 'ITALY', flag: '🇮🇹' },
  { name: { zh: '西班牙', en: 'Spain' }, code: 'SPAIN', flag: '🇪🇸' },
  { name: { zh: '俄罗斯', en: 'Russia' }, code: 'RUSSIAN FEDERATION', flag: '🇷🇺' },
  { name: { zh: '乌克兰', en: 'Ukraine' }, code: 'UKRAINE', flag: '🇺🇦' },
  { name: { zh: '波兰', en: 'Poland' }, code: 'POLAND', flag: '🇵🇱' },
  { name: { zh: '荷兰', en: 'Netherlands' }, code: 'NETHERLANDS', flag: '🇳🇱' },
  { name: { zh: '比利时', en: 'Belgium' }, code: 'BELGIUM', flag: '🇧🇪' },
  { name: { zh: '瑞典', en: 'Sweden' }, code: 'SWEDEN', flag: '🇸🇪' },
  { name: { zh: '瑞士', en: 'Switzerland' }, code: 'SWITZERLAND', flag: '🇨🇭' },
  { name: { zh: '奥地利', en: 'Austria' }, code: 'AUSTRIA', flag: '🇦🇹' },
  { name: { zh: '葡萄牙', en: 'Portugal' }, code: 'PORTUGAL', flag: '🇵🇹' },
  { name: { zh: '希腊', en: 'Greece' }, code: 'GREECE', flag: '🇬🇷' },
  { name: { zh: '丹麦', en: 'Denmark' }, code: 'DENMARK', flag: '🇩🇰' },
  { name: { zh: '芬兰', en: 'Finland' }, code: 'FINLAND', flag: '🇫🇮' },
  { name: { zh: '挪威', en: 'Norway' }, code: 'NORWAY', flag: '🇳🇴' },
  { name: { zh: '爱尔兰', en: 'Ireland' }, code: 'IRELAND', flag: '🇮🇪' },
  { name: { zh: '捷克', en: 'Czech Republic' }, code: 'CZECH REPUBLIC', flag: '🇨🇿' },
  { name: { zh: '罗马尼亚', en: 'Romania' }, code: 'ROMANIA', flag: '🇷🇴' },
  { name: { zh: '匈牙利', en: 'Hungary' }, code: 'HUNGARY', flag: '🇭🇺' },
  { name: { zh: '保加利亚', en: 'Bulgaria' }, code: 'BULGARIA', flag: '🇧🇬' },
  { name: { zh: '塞尔维亚', en: 'Serbia' }, code: 'SERBIA', flag: '🇷🇸' },
  { name: { zh: '克罗地亚', en: 'Croatia' }, code: 'CROATIA', flag: '🇭🇷' },
  { name: { zh: '斯洛伐克', en: 'Slovakia' }, code: 'SLOVAKIA', flag: '🇸🇰' },
  { name: { zh: '斯洛文尼亚', en: 'Slovenia' }, code: 'SLOVENIA', flag: '🇸🇮' },
  { name: { zh: '立陶宛', en: 'Lithuania' }, code: 'LITHUANIA', flag: '🇱🇹' },
  { name: { zh: '拉脱维亚', en: 'Latvia' }, code: 'LATVIA', flag: '🇱🇻' },
  { name: { zh: '爱沙尼亚', en: 'Estonia' }, code: 'ESTONIA', flag: '🇪🇪' },
  { name: { zh: '白俄罗斯', en: 'Belarus' }, code: 'BELARUS', flag: '🇧🇾' },
  { name: { zh: '摩尔多瓦', en: 'Moldova' }, code: 'MOLDOVA, REPUBLIC OF', flag: '🇲🇩' },
  { name: { zh: '阿尔巴尼亚', en: 'Albania' }, code: 'ALBANIA', flag: '🇦🇱' },
  { name: { zh: '北马其顿', en: 'North Macedonia' }, code: 'NORTH MACEDONIA', flag: '🇲🇰' },
  { name: { zh: '黑山', en: 'Montenegro' }, code: 'MONTENEGRO', flag: '🇲🇪' },
  { name: { zh: '波黑', en: 'Bosnia and Herzegovina' }, code: 'BOSNIA AND HERZEGOVINA', flag: '🇧🇦' },
  { name: { zh: '卢森堡', en: 'Luxembourg' }, code: 'LUXEMBOURG', flag: '🇱🇺' },
  { name: { zh: '马耳他', en: 'Malta' }, code: 'MALTA', flag: '🇲🇹' },
  { name: { zh: '冰岛', en: 'Iceland' }, code: 'ICELAND', flag: '🇮🇸' },
  { name: { zh: '安道尔', en: 'Andorra' }, code: 'ANDORRA', flag: '🇦🇩' },
  { name: { zh: '摩纳哥', en: 'Monaco' }, code: 'MONACO', flag: '🇲🇨' },
  { name: { zh: '列支敦士登', en: 'Liechtenstein' }, code: 'LIECHTENSTEIN', flag: '🇱🇮' },
  { name: { zh: '圣马力诺', en: 'San Marino' }, code: 'SAN MARINO', flag: '🇸🇲' },
  { name: { zh: '梵蒂冈', en: 'Vatican City' }, code: 'HOLY SEE', flag: '🇻🇦' },

  // North America
  { name: { zh: '美国', en: 'United States' }, code: 'UNITED STATES OF AMERICA', flag: '🇺🇸' },
  { name: { zh: '加拿大', en: 'Canada' }, code: 'CANADA', flag: '🇨🇦' },
  { name: { zh: '墨西哥', en: 'Mexico' }, code: 'MEXICO', flag: '🇲🇽' },
  { name: { zh: '古巴', en: 'Cuba' }, code: 'CUBA', flag: '🇨🇺' },
  { name: { zh: '牙买加', en: 'Jamaica' }, code: 'JAMAICA', flag: '🇯🇲' },
  { name: { zh: '巴哈马', en: 'Bahamas' }, code: 'BAHAMAS', flag: '🇧🇸' },
  { name: { zh: '多米尼加共和国', en: 'Dominican Republic' }, code: 'DOMINICAN REPUBLIC', flag: '🇩🇴' },
  { name: { zh: '哥斯达黎加', en: 'Costa Rica' }, code: 'COSTA RICA', flag: '🇨🇷' },
  { name: { zh: '巴拿马', en: 'Panama' }, code: 'PANAMA', flag: '🇵🇦' },
  { name: { zh: '危地马拉', en: 'Guatemala' }, code: 'GUATEMALA', flag: '🇬🇹' },
  { name: { zh: '洪都拉斯', en: 'Honduras' }, code: 'HONDURAS', flag: '🇭🇳' },
  { name: { zh: '萨尔瓦多', en: 'El Salvador' }, code: 'EL SALVADOR', flag: '🇸🇻' },
  { name: { zh: '尼加拉瓜', en: 'Nicaragua' }, code: 'NICARAGUA', flag: '🇳🇮' },
  { name: { zh: '海地', en: 'Haiti' }, code: 'HAITI', flag: '🇭🇹' },
  { name: { zh: '特立尼达和多巴哥', en: 'Trinidad and Tobago' }, code: 'TRINIDAD AND TOBAGO', flag: '🇹🇹' },
  { name: { zh: '伯利兹', en: 'Belize' }, code: 'BELIZE', flag: '🇧🇿' },

  // South America
  { name: { zh: '巴西', en: 'Brazil' }, code: 'BRAZIL', flag: '🇧🇷' },
  { name: { zh: '阿根廷', en: 'Argentina' }, code: 'ARGENTINA', flag: '🇦🇷' },
  { name: { zh: '哥伦比亚', en: 'Colombia' }, code: 'COLOMBIA', flag: '🇨🇴' },
  { name: { zh: '秘鲁', en: 'Peru' }, code: 'PERU', flag: '🇵🇪' },
  { name: { zh: '智利', en: 'Chile' }, code: 'CHILE', flag: '🇨🇱' },
  { name: { zh: '委内瑞拉', en: 'Venezuela' }, code: 'VENEZUELA, BOLIVARIAN REPUBLIC OF', flag: '🇻🇪' },
  { name: { zh: '厄瓜多尔', en: 'Ecuador' }, code: 'ECUADOR', flag: '🇪🇨' },
  { name: { zh: '玻利维亚', en: 'Bolivia' }, code: 'BOLIVIA, PLURINATIONAL STATE OF', flag: '🇧🇴' },
  { name: { zh: '巴拉圭', en: 'Paraguay' }, code: 'PARAGUAY', flag: '🇵🇾' },
  { name: { zh: '乌拉圭', en: 'Uruguay' }, code: 'URUGUAY', flag: '🇺🇾' },
  { name: { zh: '圭亚那', en: 'Guyana' }, code: 'GUYANA', flag: '🇬🇾' },
  { name: { zh: '苏里南', en: 'Suriname' }, code: 'SURINAME', flag: '🇸🇷' },

  // Africa
  { name: { zh: '南非', en: 'South Africa' }, code: 'SOUTH AFRICA', flag: '🇿🇦' },
  { name: { zh: '尼日利亚', en: 'Nigeria' }, code: 'NIGERIA', flag: '🇳🇬' },
  { name: { zh: '埃及', en: 'Egypt' }, code: 'EGYPT', flag: '🇪🇬' },
  { name: { zh: '肯尼亚', en: 'Kenya' }, code: 'KENYA', flag: '🇰🇪' },
  { name: { zh: '埃塞俄比亚', en: 'Ethiopia' }, code: 'ETHIOPIA', flag: '🇪🇹' },
  { name: { zh: '加纳', en: 'Ghana' }, code: 'GHANA', flag: '🇬🇭' },
  { name: { zh: '摩洛哥', en: 'Morocco' }, code: 'MOROCCO', flag: '🇲🇦' },
  { name: { zh: '阿尔及利亚', en: 'Algeria' }, code: 'ALGERIA', flag: '🇩🇿' },
  { name: { zh: '突尼斯', en: 'Tunisia' }, code: 'TUNISIA', flag: '🇹🇳' },
  { name: { zh: '坦桑尼亚', en: 'Tanzania' }, code: 'TANZANIA, UNITED REPUBLIC OF', flag: '🇹🇿' },
  { name: { zh: '乌干达', en: 'Uganda' }, code: 'UGANDA', flag: '🇺🇬' },
  { name: { zh: '卢旺达', en: 'Rwanda' }, code: 'RWANDA', flag: '🇷🇼' },
  { name: { zh: '塞内加尔', en: 'Senegal' }, code: 'SENEGAL', flag: '🇸🇳' },
  { name: { zh: '喀麦隆', en: 'Cameroon' }, code: 'CAMEROON', flag: '🇨🇲' },
  { name: { zh: '科特迪瓦', en: 'Côte d\'Ivoire' }, code: 'CÔTE D\'IVOIRE', flag: '🇨🇮' },
  { name: { zh: '安哥拉', en: 'Angola' }, code: 'ANGOLA', flag: '🇦🇴' },
  { name: { zh: '津巴布韦', en: 'Zimbabwe' }, code: 'ZIMBABWE', flag: '🇿🇼' },
  { name: { zh: '苏丹', en: 'Sudan' }, code: 'SUDAN', flag: '🇸🇩' },
  { name: { zh: '利比亚', en: 'Libya' }, code: 'LIBYA', flag: '🇱🇾' },
  { name: { zh: '纳米比亚', en: 'Namibia' }, code: 'NAMIBIA', flag: '🇳🇦' },
  { name: { zh: '博茨瓦纳', en: 'Botswana' }, code: 'BOTSWANA', flag: '🇧🇼' },
  { name: { zh: '赞比亚', en: 'Zambia' }, code: 'ZAMBIA', flag: '🇿🇲' },
  { name: { zh: '莫桑比克', en: 'Mozambique' }, code: 'MOZAMBIQUE', flag: '🇲🇿' },
  { name: { zh: '马达加斯加', en: 'Madagascar' }, code: 'MADAGASCAR', flag: '🇲🇬' },
  { name: { zh: '毛里求斯', en: 'Mauritius' }, code: 'MAURITIUS', flag: '🇲🇺' },
  { name: { zh: '塞舌尔', en: 'Seychelles' }, code: 'SEYCHELLES', flag: '🇸🇨' },

  // Oceania
  { name: { zh: '澳大利亚', en: 'Australia' }, code: 'AUSTRALIA', flag: '🇦🇺' },
  { name: { zh: '新西兰', en: 'New Zealand' }, code: 'NEW ZEALAND', flag: '🇳🇿' },
  { name: { zh: '巴布亚新几内亚', en: 'Papua New Guinea' }, code: 'PAPUA NEW GUINEA', flag: '🇵🇬' },
  { name: { zh: '斐济', en: 'Fiji' }, code: 'FIJI', flag: '🇫🇯' },
  { name: { zh: '所罗门群岛', en: 'Solomon Islands' }, code: 'SOLOMON ISLANDS', flag: '🇸🇧' },
  { name: { zh: '瓦努阿图', en: 'Vanuatu' }, code: 'VANUATU', flag: '🇻🇺' },
  { name: { zh: '萨摩亚', en: 'Samoa' }, code: 'SAMOA', flag: '🇼🇸' },
  { name: { zh: '基里巴斯', en: 'Kiribati' }, code: 'KIRIBATI', flag: '🇰🇮' },
  { name: { zh: '汤加', en: 'Tonga' }, code: 'TONGA', flag: '🇹🇴' },
  { name: { zh: '密克罗尼西亚', en: 'Micronesia' }, code: 'MICRONESIA, FEDERATED STATES OF', flag: '🇫🇲' },
  { name: { zh: '马绍尔群岛', en: 'Marshall Islands' }, code: 'MARSHALL ISLANDS', flag: '🇲🇭' },
  { name: { zh: '帕劳', en: 'Palau' }, code: 'PALAU', flag: '🇵🇼' },
  { name: { zh: '瑙鲁', en: 'Nauru' }, code: 'NAURU', flag: '🇳🇷' },
  { name: { zh: '图瓦卢', en: 'Tuvalu' }, code: 'TUVALU', flag: '🇹🇻' }
];
